<template>
  <div class="ranking-more">
    <van-nav-bar
      title="热门排行榜"
      left-arrow
      @click-left="onBack"
      fixed
    />

    <div class="filter-bar">
      <div class="filter-scroll">
        <van-tag
          v-for="cat in categories"
          :key="cat.id"
          :type="selectedCategory === cat.name ? 'primary' : 'default'"
          @click="selectCategory(cat.name)"
          class="filter-tag"
        >
          {{ cat.name }}
        </van-tag>
      </div>
    </div>

    <div class="content">
      <van-loading v-if="loading" class="loading" />

      <div class="list">
        <div
          v-for="item in currentList"
          :key="item.id"
          class="list-item"
        >
          <div class="item-cover" @click.stop="searchByTitle(item.title)">
            <img :src="item.src" v-if="item.src" :alt="item.title" />
            <div v-else class="cover-placeholder">
              <van-icon name="image" size="32" />
            </div>
          </div>
          <div class="item-info" @click="openLink(item.shareLink)">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">{{ item.desc }}</div>
            <div class="item-meta">
              <van-tag size="small" type="success">{{ item.drive }}</van-tag>
            </div>
          </div>
        </div>
      </div>

      <div class="page-info" v-if="!loading && total > 0">
        共 {{ total }} 条，每页 {{ limit }} 条
      </div>

      <div class="pagination-wrapper" v-if="!loading && total > 0">
        <div class="page-btns">
          <van-button
            size="small"
            :disabled="currentPage <= 1"
            @click="prevPage"
          >上一页</van-button>
          <span class="page-indicator">{{ currentPage }} / {{ totalPage }}</span>
          <van-button
            size="small"
            :disabled="currentPage >= totalPage"
            @click="nextPage"
          >下一页</van-button>
        </div>
        <div class="page-jump">
          <span>跳至</span>
          <van-field
            v-model="jumpPage"
            type="number"
            size="small"
            class="jump-input"
            @blur="jumpToPage"
            placeholder="页码"
          />
          <span>页</span>
        </div>
      </div>

      <div v-if="!loading && allList.length === 0" class="empty">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { getRanking, getHome } from '../utils/api';

export default {
  name: 'RankingMore',
  data() {
    return {
      allList: [],
      categories: [],
      selectedCategory: '电视剧',
      loading: false,
      currentPage: 1,
      limit: 20,
      jumpPage: ''
    };
  },
  computed: {
    total() {
      return this.allList.length;
    },
    totalPage() {
      return Math.ceil(this.total / this.limit);
    },
    currentList() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.allList.slice(start, end);
    }
  },
  mounted() {
    this.fetchCategories();
  },
  methods: {
    async fetchCategories() {
      // try {
      //   const res = await getHome({ theme: 'btlm-V65' });
      //   if (res.code === 0 && res.data && res.data.categories) {
      //     this.categories = res.data.categories;
      //   }
      // } catch (error) {
      //   console.error('Fetch categories error:', error);
      // }
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.currentPage = 1;
      try {
        const res = await getRanking({
          channel: this.selectedCategory
        });
        if (res.code === 0 && res.data) {
          this.allList = res.data.list || [];
        }
      } catch (error) {
        this.$toast('加载失败');
      } finally {
        this.loading = false;
      }
    },
    selectCategory(name) {
      if (this.selectedCategory === name) return;
      this.selectedCategory = name;
      this.fetchData();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPage) {
        this.currentPage++;
      }
    },
    jumpToPage() {
      const page = parseInt(this.jumpPage);
      if (page && page >= 1 && page <= this.totalPage) {
        this.currentPage = page;
      }
      this.jumpPage = '';
    },
    searchByTitle(title) {
      this.$router.push({
        path: '/search',
        query: { q: title, drive: '' }
      });
    },
    onBack() {
      this.$router.back();
    },
    openLink(url) {
      if (url) {
        location.href = url;
      }
    }
  }
};
</script>

<style scoped>
.ranking-more {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
}

.filter-bar {
  background: #fff;
  padding: 12px;
  position: sticky;
  top: 46px;
  z-index: 10;
}

.filter-scroll {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.filter-tag {
  flex-shrink: 0;
  cursor: pointer;
}

.content {
  padding: 12px;
}

.loading {
  text-align: center;
  padding: 20px;
}

.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.list-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.item-cover {
  width: 100%;
  aspect-ratio: 3 / 4;
  background: #f0f0f0;
  cursor: pointer;
}

.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
}

.item-info {
  padding: 10px;
  cursor: pointer;
}

.item-title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-desc {
  font-size: 11px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 4px;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.page-info {
  text-align: center;
  padding: 12px;
  color: #666;
  font-size: 14px;
}

.pagination-wrapper {
  padding: 16px 12px;
  background: #fff;
  border-radius: 8px;
  margin-top: 12px;
}

.page-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.page-indicator {
  font-size: 14px;
  color: #333;
  min-width: 60px;
  text-align: center;
}

.page-jump {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.jump-input {
  width: 60px;
  text-align: center;
}

.empty {
  text-align: center;
  padding: 40px;
  color: #999;
}
</style>
